export default "__VITE_ASSET__Bqcue2m4__"